module.exports = __webpack_public_path__ + "img/RIREKI_BONUS.fc0833c9.png";